import makeRequestUrl from './url.js';

module.exports = prefix => {
    const domain = '//box2-pyp-api.chuxingyouhui.com/api';
    // const domain = '//box1-pyp-api.chuxingyouhui.com/api';
    // const domain = '//172.16.222.214:3000/api';
    const blackCardDomain = '//box-m.black-unique.com';
    const fanxianDomain = '//box-fanxian-api.chuxingyouhui.com';

    const lbsDomain = '//lbs.chuxingyouhui.com/api';
    const marketingDomain = '//box-market.chuxingyouhui.com/promo-bargain-api';
    const privilegeDomain = `//box-privilege-api.black-unique.com`;
    const privilegeApiDomain = `//box-privilege-api.black-unique.com`;
    const vipMemberDomain = `//box-vip-member.chuxingyouhui.com`;
    const annualDomain = `//test-annual-summary-api.chuxingyouhui.com`;
    const facadeDomain = `//box-facade-api.black-unique.com`;
    const adsDomain = `//${prefix}-advertise-api.black-unique.com`;

    const api = makeRequestUrl({
        blackCardDomain,
        domain,
        lbsDomain,
        marketingDomain,
        fanxianDomain,
        privilegeDomain,
        privilegeApiDomain,
        vipMemberDomain,
        facadeDomain,
        adsDomain,
    });

    exports.domain = domain;
    exports.api = api;
    exports.blackCardDomain = blackCardDomain;
    exports.fanxianDomain = fanxianDomain;
    exports.lbsDomain = lbsDomain;
    exports.marketingDomain = marketingDomain;
    exports.privilegeApiDomain = privilegeApiDomain;
    exports.privilegeDomain = privilegeDomain;
    exports.vipMemberDomain = vipMemberDomain;
    exports.annualDomain = annualDomain;
    exports.facadeDomain = facadeDomain;
    exports.adsDomain = adsDomain;

    // 环境类型标识
    exports.envType = 'dev';
    exports.envPrefix = prefix;

    // app下载链接
    exports.appDownloadUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.black.unique';

    return exports;
};
